export default __webpack_public_path__ + "static/favicon-a3e8455c74d88850bac2039877453fa0.png";